// extracted by mini-css-extract-plugin
export var label = "_ir-0";
export var treatmentCard = "_ir-1";